import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconBusinessAiInterviewOutline from './icon-business-ai-interview-outline.vue';

const IconBusinessAiInterviewOutline = Object.assign(_IconBusinessAiInterviewOutline, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconBusinessAiInterviewOutline.name, _IconBusinessAiInterviewOutline);
  }
});

export default IconBusinessAiInterviewOutline;
